import { Link } from "react-router-dom";
import type { WorkFeedItem } from "./workFeed";
import styles from "./Dashboard.module.css";
export default function NeedsAttention({
  items,
  approvals,
}: {
  items: WorkFeedItem[];
  approvals: number;
}) {
  const attention = items
    .filter(
      (item) =>
        item.attentionReason === "failed" ||
        item.attentionReason === "unacknowledged-change",
    )
    .slice(0, 3);
  if (!attention.length && !approvals) return null;
  return (
    <section className={styles.attention} aria-labelledby="attention-title">
      <h2 id="attention-title">Needs attention</h2>
      {approvals > 0 && (
        <Link to="/agent?tab=approvals">
          {approvals} {approvals === 1 ? "plan needs" : "plans need"} approval ·
          Review steps and credits
        </Link>
      )}
      {attention.map((item) => (
        <Link key={item.key} to={item.href}>
          <strong>{item.title}</strong> ·{" "}
          {item.attentionReason === "unacknowledged-change"
            ? `${item.stateLabel} · Inspect changes`
            : "Failed · Open to resolve"}
        </Link>
      ))}
    </section>
  );
}
